<template>
  <div>
    <el-container>
  <el-main>
      <el-button @click="$router.push('/codeSearch')" type="primary">行政复议网上申请</el-button>
      <el-button  @click="$router.push('/documentsList')" type="success">行政复议文书公开</el-button>
  </el-main>
</el-container>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log(this);
  }
}
</script>

<style lang="scss" scoped>

</style>
